<template>
    <span>
        <select v-model="ComputedValue">
            <option value="No Change" title="The user's access is not altered by this company/role.">Unaffected</option>
            <option value="Allowed" title="Users in the company/role have access (unless another company/role blocks them)">Allowed</option>
            <option title="Users in the company/role have no access" value="Blocked">Blocked</option>
        </select>
    </span>
</template>

<script>
    export default {
        name: 'NullableCompanySelect',
        props: ["value"],
        computed: {
            ComputedValue: {
                get: function(){
                    return (this.value === false) ? "Blocked" : (this.value === true ? "Allowed" : "No Change");
                },
                set: function (newValue) {
                    switch (newValue) {
                        case "Blocked":
                            this.$emit('input', false);
                            break;
                        case "Allowed":
                            this.$emit('input', true);
                            break;
                        case "No Change":
                            this.$emit('input', null);
                            break;
                    }
                }
            }
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->